export default "__VITE_ASSET__ic_vfee___"